import { $host } from "./index";

export const createPost = async (post) => {
    const {data} = await $host.post('web/posts/', post);
    return data;
}

export const deletePost = async (id) => {
    const {data} = await $host.post('web/posts/remove', id);
    return data;
}

export const fetchNews = async () => {
    const {data} = await $host.get('web/posts/news');
    return data;
}

export const fetchPromotions = async () => {
    const {data} = await $host.get('web/posts/promotions');
    return data;
}

export const fetchOnePost = async(id) => {
    const {data} = await $host.get('web/posts/' + id);
    return data;
}

export const getPostStatistic = async (id) => {
  const {data} = await $host.get('web/posts/' + id + '/statistics');
  return data;
}